import { RoundedBox } from "@react-three/drei";

import { redMaterial, boxGeometry } from "@utils";

export function Tube({ position = [0, 0, 0], args = [3.5, 0.1, 0.1], bad = false }) {

    const TubeMesh = () => {
        if (bad) {
            return (
                < mesh
                    castShadow
                    receiveShadow
                    geometry={boxGeometry}
                    material={redMaterial}
                    position={position}
                    scale={args}
                />
            );
        }

        return (
            <RoundedBox
                castShadow
                receiveShadow
                args={args}
                position={position}
                radius={0.05}
                smoothness={4}
                bevelSegments={4}
                creaseAngle={0.4}
                material={redMaterial}
            />
        )
    }
    
    return TubeMesh()
}